/* collection-new-arrivals.js */

document.addEventListener('DOMContentLoaded', function () {

  var preloadCache = Object.create(null);

  function preload(url) {
    if (!url || preloadCache[url]) return preloadCache[url];
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
    preloadCache[url] = img;
    return img;
  }

  function applySrc(el, url) {
    if (!el || !url) return;
    if (!el._cnaApplyGen) el._cnaApplyGen = 0;
    el._cnaApplyGen += 1;
    var gen = el._cnaApplyGen;
    var cached = preload(url);

    function commit() {
      if (el._cnaApplyGen !== gen) return;
      el.src = url;
    }

    if (cached.complete && cached.naturalWidth) {
      commit();
    } else {
      cached.onload = commit;
    }
  }

  /* ── Sort dropdown ── */
  var sortBtn   = document.getElementById('cnaSortBtn');
  var sortPanel = document.getElementById('cnaSortPanel');

  if (sortBtn && sortPanel) {
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      sortPanel.classList.toggle('open');
    });

    document.addEventListener('click', function () {
      sortPanel.classList.remove('open');
    });

    var params = new URLSearchParams(window.location.search);
    var activeSort = params.get('sort_by');
    if (activeSort) {
      sortPanel.querySelectorAll('a').forEach(function (a) {
        var url = new URL(a.href, window.location.origin);
        if (url.searchParams.get('sort_by') === activeSort) {
          a.classList.add('active');
        }
      });
    }
  }

  /* ── Filter sidebar ── */
  var filterBtn     = document.getElementById('cnaFilterBtn');
  var filterPanel   = document.getElementById('cnaFilterPanel');
  var filterOverlay = document.getElementById('cnaFilterOverlay');
  var filterClose   = document.getElementById('cnaFilterClose');
  var applyFilters  = document.getElementById('cnaApplyFilters');

  function openFilter() {
    filterPanel.classList.add('open');
    filterOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilter() {
    filterPanel.classList.remove('open');
    filterOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (filterBtn)     filterBtn.addEventListener('click', openFilter);
  if (filterClose)   filterClose.addEventListener('click', closeFilter);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);
  if (applyFilters)  applyFilters.addEventListener('click', closeFilter);

  /* ── Product cards: gallery dots + intentional swipe ── */
  function initProductCard(card) {
    var imageWrap = card.querySelector('.cna-product-image-wrap');
    var mainImg = imageWrap && imageWrap.querySelector('.cna-product-image-main, img:first-child');
    if (!mainImg || !imageWrap) return;

    var images = imageWrap.dataset.images
      ? imageWrap.dataset.images.split('||').filter(Boolean)
      : [];
    var currentIndex = 0;
    var dots = imageWrap.querySelectorAll('.cna-card-dot');

    function updateDots(index) {
      dots.forEach(function (d) {
        var dotIndex = parseInt(d.dataset.imageIndex, 10);
        d.classList.toggle('is-active', dotIndex === index);
      });
    }

    function showGalleryAt(index) {
      if (!images.length) return;
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;

      currentIndex = index;
      imageWrap.dataset.galleryIndex = String(index);
      applySrc(mainImg, images[index]);
      updateDots(index);

      if (index + 1 < images.length) preload(images[index + 1]);
      if (index - 1 >= 0) preload(images[index - 1]);
    }

    if (images.length <= 1) return;

    images.forEach(function (url, i) {
      if (i < 4) preload(url);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('mouseenter', function () {
        var index = parseInt(dot.dataset.imageIndex, 10);
        if (images[index]) preload(images[index]);
      });
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showGalleryAt(parseInt(dot.dataset.imageIndex, 10));
      });
    });

    /* Intentional swipe: long enough + clearly horizontal so page scroll stays easy */
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var didSwipe = false;
    var axis = null; /* null | 'x' | 'y' */
    var SWIPE_THRESHOLD = 56;
    var AXIS_LOCK = 14;
    var HORIZONTAL_RATIO = 1.6;

    imageWrap.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
      didSwipe = false;
      axis = null;
    }, { passive: true });

    imageWrap.addEventListener('touchmove', function (e) {
      if (!tracking || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      var absX = Math.abs(dx);
      var absY = Math.abs(dy);

      if (!axis && (absX > AXIS_LOCK || absY > AXIS_LOCK)) {
        axis = absX > absY * HORIZONTAL_RATIO ? 'x' : 'y';
      }

      if (axis === 'x') {
        e.preventDefault();
      }
    }, { passive: false });

    imageWrap.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;

      if (axis !== 'x') {
        axis = null;
        return;
      }

      var touch = e.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;

      if (Math.abs(dx) >= SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy) * HORIZONTAL_RATIO) {
        didSwipe = true;
        showGalleryAt(currentIndex + (dx < 0 ? 1 : -1));
      }
      axis = null;
    }, { passive: true });

    imageWrap.addEventListener('touchcancel', function () {
      tracking = false;
      axis = null;
    }, { passive: true });

    var imageLink = imageWrap.querySelector('.cna-product-image-link');
    if (imageLink) {
      imageLink.addEventListener('click', function (e) {
        if (didSwipe) {
          e.preventDefault();
          didSwipe = false;
        }
      });
    }
  }

  document.querySelectorAll('.cna-product-card').forEach(initProductCard);

});
